import minSvgDataUri from 'mini-svg-data-uri';

/**
 * svg文字列->dataUriに変換する。また、その際、svg文字列内に埋め込まれた任意の文字列を、リプレースすることができる。
 *
 * @param svgString svg文字列
 * @param mapper svg文字列中の置き換えパターン。
 * @returns dataUri形式に変換されたsvg文字列
 */
export default (svgString: string, mapper: Record<string, string>): string => {
  let result = svgString;
  Object.entries(mapper).forEach(([target, value]) => {
    result = result.replaceAll(target, value);
  });
  return minSvgDataUri(result);
};
